import { render, staticRenderFns } from "./cargoCustomInfoFileUpload.vue?vue&type=template&id=2ec44537&scoped=true&"
import script from "./cargoCustomInfoFileUpload.vue?vue&type=script&lang=js&"
export * from "./cargoCustomInfoFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./cargoCustomInfoFileUpload.vue?vue&type=style&index=0&id=2ec44537&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec44537",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ec44537')) {
      api.createRecord('2ec44537', component.options)
    } else {
      api.reload('2ec44537', component.options)
    }
    module.hot.accept("./cargoCustomInfoFileUpload.vue?vue&type=template&id=2ec44537&scoped=true&", function () {
      api.rerender('2ec44537', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/cargoCustomInfoFileUpload.vue"
export default component.exports